import { useMemo } from "react";
import { useTranslation } from "react-i18next";

function ApproveStatusOption() {

    const { t } = useTranslation();
    const statusOptions = [
        { value: '', key: "all" },
        { value: 'Approved', key: "approve" },
        { value: 'Rejected', key: "reject" },
        { value: 'Draft', key: "draft" },
        { value: 'Pending', key: "pending" },
    ];
    const modifiedStatus = useMemo(() => {
        const dropdown = statusOptions.map((opt) => ({
            ...opt,
            label: t(`approve-status.${opt.key}`),
            value: opt.value,
        }))
        return dropdown

    }, [statusOptions])



    return {
        modifiedStatus
    }
}

export default ApproveStatusOption;
